import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "0563d448-486b-4266-9d43-51a53d1a6394",
    content: "Whenever the room’s absorption is small (< 0.1)",
    options: {},
  },
  {
    id: "9a82bb89-ad0c-4dff-91b5-70a823b2ebbb",
    content: "Whenever the room’s absorption is is high (> 0.5)",
    options: {},
  },
  {
    id: "7d65c669-f033-4903-9599-2afaf6e3175e",
    content: "Whenever all the room’s absorption coefficients are equal",
    options: {},
  },
  {
    id: "55c641f7-4162-4c30-917b-9700c2bf6109",
    content: "Whenever the room has a high surface area",
    options: {},
  },
];

export const task: Task = {
  id: "6f640bae-5f60-47ef-9240-e1da87632946",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0563d448-486b-4266-9d43-51a53d1a6394"],
};
